"use strict";
import React from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./Separator-css";
import classNames from "classnames";
import { makeSpacingVariants } from "../../../utils/makeSpacingVariants";
export const Separator = ({
  direction = "horizontal",
  size = "",
  className,
  spacing,
  outset,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        styles.separator({
          ...direction === "horizontal" ? makeSpacingVariants({ paddingBlock: spacing }) : {},
          ...direction === "horizontal" ? makeSpacingVariants({ marginInline: outset }) : {},
          ...direction === "vertical" ? makeSpacingVariants({ paddingInline: spacing }) : {},
          ...direction === "vertical" ? makeSpacingVariants({ marginBlock: outset }) : {}
        }),
        className
      ),
      role: "separator",
      "aria-orientation": direction,
      style: assignInlineVars({ [styles.size]: size }),
      ...props
    }
  );
};
